// CATEGORY
const categoryWidth = 200
const categoryHeight = 200
const categoryMaxSize = 200 // KB

// ITEM
const itemWidth = 512
const itemHeight = 512
const itemMaxSize = 200

// MODIFIER GROUP
const modifierGroupWidth = 100
const modifierGroupHeight = 100
const modifierGroupSize = 200

// MODIFIER OPTION
const modifierOptionWidth = 100
const modifierOptionHeight = 100
const modifierOptionSize = 200

// BANNERS
const bannerWidth = 1024
const bannerHeight = 512

// BRANCH
const branchWidth = 512
const branchHeight = 512
const branchMaxHeight = 500

export {
  categoryWidth,
  categoryHeight,
  categoryMaxSize,
  itemWidth,
  itemHeight,
  itemMaxSize,
  modifierGroupWidth,
  modifierGroupHeight,
  modifierGroupSize,
  modifierOptionWidth,
  modifierOptionHeight,
  modifierOptionSize,
  bannerWidth,
  bannerHeight,
  branchWidth,
  branchHeight,
  branchMaxHeight,
}
